var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechnologywhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2312 7.10315H6.8053V13.5291H13.2312V7.10315ZM12.2497 12.5476H7.78678V8.08463H12.2497V12.5476ZM18.1294 5.2513V4.26982H15.8609V1.66797H14.8794V4.26982H12.1942V1.66797H11.2127V4.26982H8.59234V1.66797H7.61086V4.26982H5.03678V1.66797H4.0553V4.26982H1.87012V5.2513H4.0553V7.83463H1.87012V8.81612H4.0553V11.4272H1.87012V12.4087H4.0553V15.1032H1.87012V16.0846H4.0553V18.2976H5.03678V16.1865H7.61086V18.3346H8.59234V16.1865H11.2127V18.3346H12.1942V16.1865H14.8794V18.2976H15.8609V16.0846H18.1294V15.1032H15.8609V12.4087H18.1294V11.4272H15.8609V8.81612H18.1294V7.83463H15.8609V5.2513H18.1294ZM14.8794 15.205H5.03678V5.2513H14.8794V15.205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologywhite);
export default __webpack_public_path__ + "static/media/technology white.4432efdfb96293d8b0880f66e547d18d.svg";
export { ForwardRef as ReactComponent };